module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindents"
  }, [_c('a', {
    attrs: {
      "id": "preface03"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("One-Eyed Jack:")]), _vm._v(" \\w"), _c('img', {
    attrs: {
      "alt": "e",
      "height": "14",
      "src": "images/e.jpg",
      "width": "12"
    }
  }), _vm._v("n\\-\\'īd\\-\\'jak\\")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Noun: 1:")]), _vm._v(" being, of, pertaining to, a face card or cards on which the figure is shown in profile, such cards being the jack of spades, the jack of hearts. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("2:")]), _vm._v(" a loner who has a hard time trusting anyone. "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("3:")]), _vm._v(" Navy term for a greasy hamburger topped with a fried egg. Often served during midrats—midnight rations.")]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c3e7de0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface03.vue
// module id = 78
// module chunks = 0